import { FieldsSchema } from "encharge-integration-schema";
export { FieldsSchema };
